export default "__VITE_ASSET__CSbfuvVa__"